module.exports = __webpack_public_path__ + "img/geofisica_16-9_640.9c16c18a.jpg";